import { humanRigs, type HumanProportions, type HumanRigId } from './human.js';
import { CELESTIAL_FACE_DEFAULT, celestialFaceShape, celestialSkull, resolveCelestialFace, type CelestialFaceMorph } from './celestial-face.js';

export type CelestialRigId = 'celestial-male' | 'celestial-female';
export interface CelestialProportions extends HumanProportions { faceMorph: CelestialFaceMorph }
export const CELESTIAL_RIG_VERSION = 1;
function proportions(id: CelestialRigId, motionRig: HumanRigId): CelestialProportions {
  const p = structuredClone(humanRigs[motionRig]), faceMorph = { ...CELESTIAL_FACE_DEFAULT }, face = celestialFaceShape(faceMorph, motionRig);
  return { ...p, id, bodyMorph: { breadth: 1, depth: .97, limbWidth: .96, armLength: 1.02, legLength: 1.03, torsoLength: 1, neckLength: 1.07, headSize: .98, handSize: .98 },
    muscularity: .22, muscleDefinition: .55, fatness: 0,
    faceMorph, face, skull: celestialSkull(faceMorph, motionRig), faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headMeshCell: .0035 };
}
export const celestialRigs: Record<CelestialRigId, CelestialProportions> = {
  'celestial-male': proportions('celestial-male', 'human-male'), 'celestial-female': proportions('celestial-female', 'human-female'),
};
export function celestialProportions(rig = 'celestial-male'): CelestialProportions {
  if (!(rig in celestialRigs)) throw new Error(`No Celestial morph registered for rig '${rig}'.`);
  return celestialRigs[rig as CelestialRigId];
}
export function morphCelestialProportions(source: CelestialProportions, faceId = 'standard'): CelestialProportions {
  const faceMorph = resolveCelestialFace(source.faceMorph, faceId), face = celestialFaceShape(faceMorph, source.motionRig);
  return { ...source, faceMorph, face, skull: celestialSkull(faceMorph, source.motionRig),
    faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headCacheKey: `${source.id}:${faceId}:${JSON.stringify(faceMorph)}` };
}
export const celestialStandardHeight = (rig: string) => rig === 'celestial-female' ? 1.8 : 1.9;
